import React, {Component} from "react";
import Dashboard from "./dashboard";
import PropTypes from "prop-types";
import {connect} from "react-redux";

// actions
import {reset as resetBrand} from "actions/brand/list";
import {reset as resetCategory} from "actions/category/list";
import {reset as resetGender} from "actions/gender/list";

class Show extends Component {
    static propTypes = {
        resetBrand: PropTypes.func.isRequired,
        resetCategory: PropTypes.func.isRequired,
        resetColor: PropTypes.func.isRequired,
        resetGender: PropTypes.func.isRequired,
        resetSize: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.resetBrand()
        this.props.resetCategory()
        this.props.resetGender()
    }

    render() {
        return (
            <Dashboard retailer={decodeURIComponent(this.props.match.params.id).replace('/retailers/', '')}/>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    resetBrand: () => dispatch(resetBrand()),
    resetCategory: () => dispatch(resetCategory()),
    resetGender: () => dispatch(resetGender()),
});

export default connect(
    null,
    mapDispatchToProps
)(Show);
